export default __webpack_public_path__ + "5a6810f202a08465e2b36b32f9352778.png";